import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Save } from "lucide-react";
import { toast } from "sonner";

const PAGES = [
  { key: "about", label: "About the Journal" },
  { key: "aims_scope", label: "Aims and Scope" },
  { key: "instructions", label: "Instructions for Authors" },
  { key: "peer_review", label: "Peer Review Process" },
  { key: "ethics", label: "Publication Ethics" },
  { key: "apc", label: "Article Processing Charge" },
  { key: "privacy", label: "Privacy Policy" },
  { key: "legal_notice", label: "Legal Notice (EN)" },
  { key: "legal_notice_es", label: "Aviso Legal (ES)" },
];

export default function AdminContent() {
  const [activeKey, setActiveKey] = useState("about");
  const [page, setPage] = useState({ title: "", body: "" });

  useEffect(() => {
    api.get(`/content/${activeKey}?raw=1`).then((r) => setPage({ title: r.data.title, body: r.data.body }))
      .catch(() => setPage({ title: "", body: "" }));
  }, [activeKey]);

  const save = async () => {
    try {
      await api.put(`/admin/content/${activeKey}`, page);
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
  };

  return (
    <div data-testid="admin-content">
      <h1 className="font-serif text-3xl text-[#001F3F]">Content (CMS)</h1>
      <div className="w-10 h-[2px] bg-[#2BA6A6] mt-3 mb-6"></div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <aside className="md:col-span-1">
          {PAGES.map((p) => (
            <button key={p.key} onClick={() => setActiveKey(p.key)} className={`w-full text-left px-4 py-3 text-sm border-l-4 ${activeKey === p.key ? "border-[#2BA6A6] bg-white text-[#001F3F] font-semibold" : "border-transparent text-[#001F3F]/70 hover:bg-white"}`}>
              {p.label}
            </button>
          ))}
        </aside>
        <div className="md:col-span-3 bg-white border border-gray-200 p-6">
          <label className="block text-[10px] uppercase tracking-[0.2em] font-semibold mb-1.5">Title</label>
          <input value={page.title} onChange={(e) => setPage({ ...page, title: e.target.value })} className="w-full px-3 py-2 border border-gray-200 text-sm mb-4" />
          <label className="block text-[10px] uppercase tracking-[0.2em] font-semibold mb-1.5">Body</label>
          <textarea rows={20} value={page.body} onChange={(e) => setPage({ ...page, body: e.target.value })} className="w-full px-3 py-2 border border-gray-200 text-sm font-serif leading-relaxed" data-testid="cms-body" />
          <p className="mt-1 text-[11px] text-gray-500" data-testid="cms-token-hint">Tip: write {"{{apc}}"} where the publication fee should appear — it is filled automatically from Journal Settings.</p>
          <button onClick={save} className="mt-4 bg-[#001F3F] text-white px-5 py-2 text-xs uppercase tracking-wider hover:bg-[#2BA6A6]" data-testid="cms-save"><Save className="w-3 h-3 inline mr-1" /> Save</button>
        </div>
      </div>
    </div>
  );
}
